module.exports = __webpack_public_path__ + "img/step-current.21770770.svg";